"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.titleCaseWords = void 0;
var titleCaseWords = exports.titleCaseWords = function titleCaseWords(str) {
  return str.replace(/(?:^|\s)\S/g, function (a) {
    return a.toUpperCase();
  });
};